"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = void 0;

var _Icons = require("../Icons");

/**
* ===============================
* WARNING: This file is generated
* ===============================
* Do not edit this file directly, see:
* create-react-svg-components.js
*/
var icons = {
  UI_IDEA: _Icons.IconUiIdea,
  UI_ALIGN_CENTRE: _Icons.IconUiAlignCentre,
  UI_ALIGN_LEFT: _Icons.IconUiAlignLeft,
  UI_ALIGN_RIGHT: _Icons.IconUiAlignRight,
  UI_ARROW_DOWN: _Icons.IconUiArrowDown,
  UI_ARROW_LEFT: _Icons.IconUiArrowLeft,
  UI_ARROW_RIGHT: _Icons.IconUiArrowRight,
  UI_ARROW_UP: _Icons.IconUiArrowUp,
  UI_BIN: _Icons.IconUiBin,
  UI_BLEED_AREA: _Icons.IconUiBleedArea,
  UI_BOLD: _Icons.IconUiBold,
  UI_BUSINESS_CARD_TYPE: _Icons.IconUiBusinessCardType,
  UI_BUSINESS_CARDS: _Icons.IconUiBusinessCards,
  UI_CALENDAR: _Icons.IconUiCalendar,
  UI_CART: _Icons.IconUiCart,
  UI_CHEVRON_DOWN_BOLD: _Icons.IconUiChevronDownBold,
  UI_CHEVRON_DOWN_XBOLD: _Icons.IconUiChevronDownXbold,
  UI_CHEVRON_DOWN: _Icons.IconUiChevronDown,
  UI_CHEVRON_LEFT_BOLD: _Icons.IconUiChevronLeftBold,
  UI_CHEVRON_LEFT_XBOLD: _Icons.IconUiChevronLeftXbold,
  UI_CHEVRON_LEFT: _Icons.IconUiChevronLeft,
  UI_CHEVRON_RIGHT_BOLD: _Icons.IconUiChevronRightBold,
  UI_CHEVRON_RIGHT_XBOLD: _Icons.IconUiChevronRightXbold,
  UI_CHEVRON_RIGHT_XXBOLD: _Icons.IconUiChevronRightXxbold,
  UI_CHEVRON_RIGHT: _Icons.IconUiChevronRight,
  UI_CHEVRON_UP_BOLD: _Icons.IconUiChevronUpBold,
  UI_CHEVRON_UP_XBOLD: _Icons.IconUiChevronUpXbold,
  UI_CHEVRON_UP: _Icons.IconUiChevronUp,
  UI_CLOCK_LARGE: _Icons.IconUiClockLarge,
  UI_CLOCK: _Icons.IconUiClock,
  UI_CLOSE_BOLD: _Icons.IconUiCloseBold,
  UI_CLOSE_XBOLD: _Icons.IconUiCloseXbold,
  UI_CLOSE: _Icons.IconUiClose,
  UI_COMMENTS: _Icons.IconUiComments,
  UI_DOWNLOAD: _Icons.IconUiDownload,
  UI_DUPLICATE: _Icons.IconUiDuplicate,
  UI_EDIT: _Icons.IconUiEdit,
  UI_ELEMENT_ARTWORK: _Icons.IconUiElementArtwork,
  UI_ELLIPSIS_BOLD: _Icons.IconUiEllipsisBold,
  UI_ELLIPSIS_VERTICAL_ALIGN_RIGHT_BOLD: _Icons.IconUiEllipsisVerticalAlignRightBold,
  UI_ELLIPSIS_VERTICAL_BOLD: _Icons.IconUiEllipsisVerticalBold,
  UI_ELLIPSIS: _Icons.IconUiEllipsis,
  UI_ENVELOPE: _Icons.IconUiEnvelope,
  UI_F4C3B00K: _Icons.IconUiFacebook,
  UI_FILTER: _Icons.IconUiFilter,
  UI_FLIP: _Icons.IconUiFlip,
  UI_FLYER_A4: _Icons.IconUiFlyerA4,
  UI_FLYER_A5: _Icons.IconUiFlyerA5,
  UI_FLYER_A6: _Icons.IconUiFlyerA6,
  UI_FLYER_DL: _Icons.IconUiFlyerDl,
  UI_FLYER_SQUARE: _Icons.IconUiFlyerSquare,
  UI_G00GL3_PLUS: _Icons.IconUiGooglePlus,
  UI_GRID_VIEW: _Icons.IconUiGridView,
  UI_HEART: _Icons.IconUiHeart,
  UI_HELP_CIRCLE: _Icons.IconUiHelpCircle,
  UI_HELP: _Icons.IconUiHelp,
  UI_HOLIDAY_CARD_ICON: _Icons.IconUiHolidayCardIcon,
  UI_HOME_BOLD: _Icons.IconUiHomeBold,
  UI_HOME: _Icons.IconUiHome,
  UI_INFORMATION_CIRCLE: _Icons.IconUiInformationCircle,
  UI_INFORMATION: _Icons.IconUiInformation,
  UI_INSPIRATION: _Icons.IconUiInspiration,
  UI_INST4GR4M: _Icons.IconUiInstagram,
  UI_ITALIC: _Icons.IconUiItalic,
  UI_LINKEDIN: _Icons.IconUiLinkedin,
  UI_LIST_VIEW: _Icons.IconUiListView,
  UI_MENU: _Icons.IconUiMenu,
  UI_MINUS_BOLD: _Icons.IconUiMinusBold,
  UI_MINUS_CIRCLE: _Icons.IconUiMinusCircle,
  UI_MINUS: _Icons.IconUiMinus,
  UI_MOBILE_PHONE: _Icons.IconUiMobilePhone,
  UI_MOO_DROP_BOLD: _Icons.IconUiMooDropBold,
  UI_MOO_DROP_FILL: _Icons.IconUiMooDropFill,
  UI_MOO_DROP: _Icons.IconUiMooDrop,
  UI_ORDER_HISTORY: _Icons.IconUiOrderHistory,
  UI_PADLOCK: _Icons.IconUiPadlock,
  UI_PEOPLE: _Icons.IconUiPeople,
  UI_PINTEREST: _Icons.IconUiPinterest,
  UI_PLAY_CIRCLE: _Icons.IconUiPlayCircle,
  UI_PLAY: _Icons.IconUiPlay,
  UI_PLUS_BOLD: _Icons.IconUiPlusBold,
  UI_PLUS_CIRCLE: _Icons.IconUiPlusCircle,
  UI_PLUS: _Icons.IconUiPlus,
  UI_POSTCARD_MEDIUM: _Icons.IconUiPostcardMedium,
  UI_POSTCARD_SMALL: _Icons.IconUiPostcardSmall,
  UI_PREVIEW: _Icons.IconUiPreview,
  UI_QUOTE_LEFT: _Icons.IconUiQuoteLeft,
  UI_REDO_BOLD: _Icons.IconUiRedoBold,
  UI_REDO: _Icons.IconUiRedo,
  UI_REFRESH: _Icons.IconUiRefresh,
  UI_ROTATE: _Icons.IconUiRotate,
  UI_SAFE_AREA: _Icons.IconUiSafeArea,
  UI_SEARCH: _Icons.IconUiSearch,
  UI_SETTINGS: _Icons.IconUiSettings,
  UI_SHARE: _Icons.IconUiShare,
  UI_TAG: _Icons.IconUiTag,
  UI_TICK_BOLD: _Icons.IconUiTickBold,
  UI_TICK_CIRCLE: _Icons.IconUiTickCircle,
  UI_TICK_XBOLD: _Icons.IconUiTickXbold,
  UI_TICK_XXBOLD: _Icons.IconUiTickXxbold,
  UI_TICK: _Icons.IconUiTick,
  UI_TRIM_AREA: _Icons.IconUiTrimArea,
  UI_TUMBLR: _Icons.IconUiTumblr,
  UI_TW1TT3R: _Icons.IconUiTwitter,
  UI_UNDO_BOLD: _Icons.IconUiUndoBold,
  UI_UNDO: _Icons.IconUiUndo,
  UI_UPLOAD: _Icons.IconUiUpload,
  UI_USER: _Icons.IconUiUser,
  UI_WARNING_CIRCLE: _Icons.IconUiWarningCircle,
  UI_WARNING: _Icons.IconUiWarning
};
exports.icons = icons;